<template>
  <div class="modal-card" style="width: auto">
    <b-loading
      :is-full-page="true"
      :active="isLoading"
      :can-cancel="false"
    ></b-loading>

    <header class="modal-card-head">
      <p class="modal-card-title has-text-centered">Participação em Aula</p>
    </header>

    <section class="modal-card-body">
      <form @submit.prevent="requestLesson">
        <b-field label="Sobre a Disciplina">
          <div class="column">
            <span>Leciona para:</span> <br />
            <br />

            <b-field>
              <b-radio
                v-model="request.eventInfo.subject.specialization"
                native-value="technologist"
              >
                Tecnólogo (nível superior)
              </b-radio>
            </b-field>

            <b-field>
              <b-radio
                v-model="request.eventInfo.subject.specialization"
                native-value="graduation"
              >
                Graduação (bacharelado e licenciatura)</b-radio
              >
            </b-field>

            <b-field>
              <b-radio
                v-model="request.eventInfo.subject.specialization"
                native-value="postGraduation"
              >
                Pós-Graduação
              </b-radio>

              <div @click="postGraduationDialog">
                <b-icon
                  icon="info-circle"
                  size="is-small"
                  class="infoIcon"
                ></b-icon>
              </div>
            </b-field>
          </div>
        </b-field>

        <b-field
          :label="
            request.eventInfo.subject.courses.length
              ? 'Cursos dos Estudantes'
              : ''
          "
          label-position="on-border"
        >
          <b-taginput
            v-model="request.eventInfo.subject.courses"
            placeholder="Cursos dos Estudantes"
          ></b-taginput>
        </b-field>

        <b-field
          label="Semestre dos Estudantes"
          custom-class="is-small"
          v-if="
            request.eventInfo.subject.specialization == 'technologist' ||
              request.eventInfo.subject.specialization == 'graduation'
          "
        >
          <b-checkbox
            v-model="request.eventInfo.subject.semester"
            native-value="1"
          >
            1º
          </b-checkbox>

          <b-checkbox
            v-model="request.eventInfo.subject.semester"
            native-value="2"
          >
            2º
          </b-checkbox>

          <b-checkbox
            v-model="request.eventInfo.subject.semester"
            native-value="3"
          >
            3º
          </b-checkbox>

          <b-checkbox
            v-model="request.eventInfo.subject.semester"
            native-value="4"
          >
            4º
          </b-checkbox>

          <b-checkbox
            v-model="request.eventInfo.subject.semester"
            native-value="5"
          >
            5º
          </b-checkbox>

          <b-checkbox
            v-model="request.eventInfo.subject.semester"
            native-value="6"
          >
            6º
          </b-checkbox>

          <b-checkbox
            v-model="request.eventInfo.subject.semester"
            native-value="7"
          >
            7º
          </b-checkbox>

          <b-checkbox
            v-model="request.eventInfo.subject.semester"
            native-value="8"
          >
            8º
          </b-checkbox>

          <b-checkbox
            v-model="request.eventInfo.subject.semester"
            native-value="9"
          >
            9º
          </b-checkbox>

          <b-checkbox
            v-model="request.eventInfo.subject.semester"
            native-value="10"
          >
            +10º
          </b-checkbox>
        </b-field>

        <b-field
          :label="
            request.eventInfo.subject.subjectName ? 'Nome da Disciplina' : ''
          "
          label-position="on-border"
          v-if="
            request.eventInfo.subject.specialization == 'technologist' ||
              request.eventInfo.subject.specialization == 'graduation'
          "
        >
          <b-input
            v-model="request.eventInfo.subject.subjectName"
            placeholder="Nome da Disciplina"
          ></b-input>
        </b-field>

        <span>
          Há um aluno responsável pela ação junto com o professor? (Sim/Não)
        </span>
        <br />
        <br />

        <b-field>
          <b-radio
            v-model="request.eventInfo.subject.hasAssistantStudent"
            :native-value="true"
          >
            Sim
          </b-radio>

          <b-radio
            v-model="request.eventInfo.subject.hasAssistantStudent"
            :native-value="false"
          >
            Não
          </b-radio>
        </b-field>

        <div
          class="columns"
          v-if="request.eventInfo.subject.hasAssistantStudent"
        >
          <div class="column">
            <b-field
              :label="
                request.eventInfo.subject.studentName ? 'Nome do Aluno' : ''
              "
              label-position="on-border"
            >
              <b-input
                v-model="request.eventInfo.subject.studentName"
                placeholder="Nome do Aluno"
              ></b-input>
            </b-field>
          </div>

          <div class="column">
            <b-field
              :label="
                request.eventInfo.subject.studentPhone ? 'Celular do Aluno' : ''
              "
              label-position="on-border"
            >
              <b-input
                v-model="request.eventInfo.subject.studentPhone"
                placeholder="Celular do Aluno"
              ></b-input>
            </b-field>
          </div>
        </div>

        <b-field
          :label="
            request.eventInfo.subject.studentEmail ? 'E-mail do Aluno' : ''
          "
          label-position="on-border"
          v-if="request.eventInfo.subject.hasAssistantStudent"
        >
          <b-input
            v-model="request.eventInfo.subject.studentEmail"
            placeholder="E-mail do Aluno"
          ></b-input>
        </b-field>
        <hr />

        <b-field label="Sobre a Participação em Aula">
          <div class="columns">
            <div class="column">
              <b-field label="Tipo de Ação" custom-class="is-small">
                <b-radio
                  v-model="request.eventInfo.isOnline"
                  :native-value="true"
                  type="is-primary"
                  :disabled="hasFormat"
                >
                  <span>Online</span>
                </b-radio>

                <b-radio
                  v-model="request.eventInfo.isOnline"
                  :native-value="false"
                  type="is-primary"
                  :disabled="hasFormat"
                >
                  <span>Presencial</span>
                </b-radio>
                <span @click="formatAlert" v-if="hasFormat">
                  <b-icon
                    type="is-info"
                    icon="info-circle"
                    class="format-icon"
                  ></b-icon>
                </span>
              </b-field>
            </div>

            <div class="column">
              <b-field
                :label="
                  request.eventInfo.attendeeQty ? 'Público estimado *' : ''
                "
                label-position="on-border"
                :min="minPublic"
              >
                <b-input
                  type="number"
                  v-model="request.eventInfo.attendeeQty"
                  placeholder="Público Estimado"
                />
              </b-field>
            </div>
          </div>
        </b-field>

        <date-time-options />

        <b-field
          :label="
            request.eventInfo.suggestedThemes.length
              ? 'Temas para a participação em aula *'
              : ''
          "
          label-position="on-border"
        >
          <b-taginput
            v-model="request.eventInfo.suggestedThemes"
            :data="themesArray"
            open-on-focus
            :keep-first="false"
            :allow-new="true"
            placeholder="Temas para a participação em aula *"
          >
            <template slot-scope="props">
              {{ props.option }}
            </template>
          </b-taginput>
        </b-field>

        <b-field
          :label="
            request.eventInfo.themesDescription ? 'Descrição dos temas *' : ''
          "
          label-position="on-border"
        >
          <b-input
            type="textarea"
            placeholder="Por favor, descreva brevemente cada tema sugerido."
            v-model="request.eventInfo.themesDescription"
          />
        </b-field>
        <span
          :style="
            request.eventInfo.themesDescription.length >= 140
              ? 'color: green'
              : 'color: red'
          "
          style="display: table; margin-left: auto;"
        >
          {{ request.eventInfo.themesDescription.length }} > 140
        </span>

        <span>Formato desejado para a Participação em Aula:</span>

        <b-field>
          <div class="columns">
            <div class="column">
              <b-radio
                v-model="request.eventInfo.isManagerConductingAlone"
                :native-value="true"
              >
                Condução Exclusiva do(a) gestor(a)
              </b-radio>
            </div>

            <div class="column">
              <b-radio
                v-model="request.eventInfo.isManagerConductingAlone"
                :native-value="false"
              >
                Interação entre o(a) gestor(a) e o(a) professor(a)
              </b-radio>
            </div>
          </div>
        </b-field>

        <span>
          Descrição do Formato:
          <b-tooltip
            label="Por favor, descreva brevemente a abordagem/conteúdos desejados para cada tema sugerido"
            position="is-right"
          >
            <b-icon
              icon="info-circle"
              size="is-small"
              class="infoIcon"
            ></b-icon>
          </b-tooltip>
        </span>

        <div class="columns">
          <div class="column">
            <b-radio
              v-model="request.eventInfo.eventType"
              native-value="lecture"
            >
              Palestra
            </b-radio>
          </div>

          <div class="column">
            <b-radio
              v-model="request.eventInfo.eventType"
              native-value="training"
            >
              Treinamento
            </b-radio>
          </div>

          <div class="column">
            <b-radio v-model="request.eventInfo.eventType" native-value="case">
              Estudo de Caso / Case
            </b-radio>
          </div>

          <div class="column">
            <b-radio v-model="request.eventInfo.eventType" native-value="other">
              Outros
            </b-radio>
          </div>
        </div>

        <b-field
          :label="
            request.eventInfo.eventDescription ? 'Descreva o formato *' : ''
          "
          label-position="on-border"
        >
          <b-input
            type="textarea"
            placeholder="Por favor, descreva brevemente o formato sugerido.."
            v-model="request.eventInfo.eventDescription"
          />
        </b-field>

        <hr />

        <b-field label="Seus Contatos">
          <b-field
            :label="account.cellphone ? 'Celular' : ''"
            label-position="on-border"
          >
            <b-select placeholder="DDD" v-model="contact.areacode">
              <option value="">DDD</option>

              <option v-for="(ddd, i) in ddds" :value="ddd" :key="i">
                {{ ddd }}
              </option>
            </b-select>

            <b-input
              placeholder="Celular"
              expanded
              v-model="contact.cellphone"
            ></b-input>
          </b-field>
        </b-field>

        <b-field
          :label="contact.lattes ? 'Plataforma Lattes - Link' : ''"
          label-position="on-border"
          style="margin-bottom: 0rem; margin-top: 1.5rem"
        >
          <b-input
            v-model="contact.lattes"
            placeholder="Plataforma Lattes - Link"
            expanded
          />
        </b-field>

        <b-field
          :label="contact.linkedin ? 'Linkedin - Link' : ''"
          label-position="on-border"
          style="margin-bottom: 0rem; margin-top: 1.5rem;"
        >
          <b-input v-model="contact.linkedin" placeholder="Linkedin - Link" />
        </b-field>

        <hr />

        <b-field
          label="Termo de Contrapartidas *"
          custom-class="has-text-dark-grey "
        >
          <div class="field">
            <b-checkbox v-model="terms.photos" class="checkbox-bottom">
              Aceito enviar prints/fotos da participação em aula e coletar as
              devidas autorizações para uso de imagem dos participantes que
              aparecerem nos prints/fotos enviados.
            </b-checkbox>
            <br />

            <b-checkbox v-model="terms.post" class="checkbox-bottom">
              Aceito publicar um post na fanpage, insta ou linkedin do(a)
              professor(a).
            </b-checkbox>
          </div>
        </b-field>

        <div class="has-text-centered">
          <button
            class="button is-primary"
            :disabled="pendencies.length > 0"
            :style="[windowWidth < 769 ? { marginBottom: 40 + 'px' } : null]"
          >
            Solicitar Participação em Aula
          </button>
        </div>

        <Pendencies :pendencies="pendencies" />
      </form>
    </section>

    <footer class="modal-card-foot">
      <button class="button" type="button" @click="$parent.close()">
        Cancelar
      </button>
    </footer>
  </div>
</template>

<script>
import { mapGetters } from "vuex";
import { commom } from "../../../mixins/commom";
import { responsive } from "../../../mixins/responsive";
import { request } from "../../../mixins/request";
import dateTimeOptions from "./date-time-options/DateTimeOptions";
import { ddds } from "../../../assets/js/ddds";
import Pendencies from "../../commom/Pendencies";

export default {
  mixins: [commom, responsive, request],

  props: ["minPublic"],

  components: {
    dateTimeOptions,
    Pendencies
  },

  data() {
    return {
      isLoading: false,
      hasFormat: false,
      ddds: [],

      contact: {
        cellphone: "",
        areacode: "",
        lattes: "",
        linkedin: ""
      },

      request: {
        opportunity: null,
        requestType: "lesson",
        eventInfo: {
          suggestedThemes: [],
          themesDescription: "",
          isOnline: "",
          isManagerConductingAlone: "",
          eventType: "",
          eventDescription: "",
          dateOptions: {
            first: {
              date: null,
              start: null,
              end: null
            },
            second: {
              date: null,
              start: null,
              end: null
            },
            third: {
              date: null,
              start: null,
              end: null
            }
          },
          attendeeQty: null,
          subject: {
            specialization: "",
            courses: [],
            semester: [],
            subjectName: "",
            hasAssistantStudent: false,
            studentName: "",
            studentPhone: "",
            studentEmail: ""
          }
        }
      },
      terms: {
        photos: false,
        post: false
      },

      themesArray: []
    };
  },

  methods: {
    requestLesson() {
      this.request.eventInfo.dateOptions.first.start = this.adjustRequestDateAndTime(
        this.request.eventInfo.dateOptions.first.date,
        this.request.eventInfo.dateOptions.first.start
      );

      this.request.eventInfo.dateOptions.first.end = this.adjustRequestDateAndTime(
        this.request.eventInfo.dateOptions.first.date,
        this.request.eventInfo.dateOptions.first.end
      );

      this.request.eventInfo.dateOptions.second.start = this.adjustRequestDateAndTime(
        this.request.eventInfo.dateOptions.second.date,
        this.request.eventInfo.dateOptions.second.start
      );

      this.request.eventInfo.dateOptions.second.end = this.adjustRequestDateAndTime(
        this.request.eventInfo.dateOptions.second.date,
        this.request.eventInfo.dateOptions.second.end
      );

      this.request.eventInfo.dateOptions.third.start = this.adjustRequestDateAndTime(
        this.request.eventInfo.dateOptions.third.date,
        this.request.eventInfo.dateOptions.third.start
      );

      this.request.eventInfo.dateOptions.third.end = this.adjustRequestDateAndTime(
        this.request.eventInfo.dateOptions.third.date,
        this.request.eventInfo.dateOptions.third.end
      );

      this.isLoading = true;
      if (this.updateAccount) {
        this.account.areacode = this.contact.areacode;
        this.account.cellphone = this.contact.cellphone;
        this.account.lattes = this.contact.lattes;
        this.account.linkedin = this.contact.linkedin;

        let formData = new FormData();
        formData.append("account", JSON.stringify(this.account));

        this.$store
          .dispatch("updateAccount", formData)
          .then(res => {
            if (res.data.result === "ok") {
              console.log(
                "Dados de contato do usuário atualizados com sucesso!"
              );
            }
          })
          .catch(() => {
            console.log(
              "Houve um erro e os dados de contato desde usuário não puderam ser atualizados."
            );
          });
      }
      this.$store
        .dispatch("makeRequest", {
          to: "lesson",
          data: {
            request: this.request
          }
        })
        .then(res => {
          if (res.data.result === "ok") {
            this.$buefy.dialog.alert({
              title: "Solicitação Recebida",
              message:
                "Sua solicitação será analisada e enviada para a empresa. A resposta pode levar algumas semanas. Em caso de dúvida, entre em contato conosco.",
              type: "is-success",
              hasIcon: true,
              icon: "check",
              iconPack: "fa",
              onConfirm: () => this.$parent.close(),
              onCancel: () => this.$parent.close()
            });
          } else {
            this.alertError(res.data);
          }
        })
        .catch(() => {
          this.alertError({ message: "UNEXPECTED_ERROR" });
        })
        .finally(() => {
          this.isLoading = false;
        });
    },

    postGraduationDialog() {
      this.$buefy.dialog.alert({
        title: "Pós-Graduação",
        message: "- Mestrado <br> - Doutorado <br> - MBA <br> - Outros"
      });
    },

    updateAccount() {
      return (
        this.contact.areacode !== this.account.areacode ||
        this.contact.cellphone !== this.account.cellphone ||
        this.contact.lattes !== this.account.lattes ||
        this.contact.linkedin !== this.account.linkedin
      );
    },

    formatAlert() {
      this.$buefy.dialog.alert(
        "Esta empresa realiza participação em aula apenas neste formato."
      );
    }
  },

  computed: {
    ...mapGetters(["opportunityBeingVisited", "account"]),

    pendencies() {
      const pendencies = [];
      if (!(this.terms.photos && this.terms.post)) {
        pendencies.push("Aceitar os termos de contrapartidas");
      }
      if (!this.request.eventInfo.subject.specialization) {
        pendencies.push("Especialização dos estudantes");
      }
      if (
        this.request.eventInfo.subject.specialization == "technologist" ||
        this.request.eventInfo.subject.specialization == "graduation"
      ) {
        if (this.request.eventInfo.subject.semester.length < 1) {
          pendencies.push("Semestre dos Estudantes");
        }
        if (!this.request.eventInfo.subject.subjectName) {
          pendencies.push("Nome da Disciplina");
        }
      }
      if (this.request.eventInfo.subject.courses.length < 1) {
        pendencies.push("Cursos dos Estudantes");
      }
      if (this.request.eventInfo.isOnline === "") {
        pendencies.push("Tipo de Ação");
      }
      if (this.request.eventInfo.attendeeQty < this.minPublic) {
        pendencies.push("O público estimado é menor que o público mínimo");
      }
      if (!this.request.eventInfo.dateOptions.first.date) {
        pendencies.push("Primeira opção de data");
      }
      if (!this.request.eventInfo.dateOptions.first.start) {
        pendencies.push("Horário de início da primeira opção de data");
      }
      if (!this.request.eventInfo.dateOptions.first.end) {
        pendencies.push("Horário final da primeira opção de data");
      }
      if (!this.request.eventInfo.dateOptions.second.date) {
        pendencies.push("Segunda opção de data");
      }
      if (!this.request.eventInfo.dateOptions.second.start) {
        pendencies.push("Horário de início da segunda opção de data");
      }
      if (!this.request.eventInfo.dateOptions.second.end) {
        pendencies.push("Horário final da segunda opção de data");
      }
      if (!this.request.eventInfo.dateOptions.third.date) {
        pendencies.push("Terceira opção de data");
      }
      if (!this.request.eventInfo.dateOptions.third.start) {
        pendencies.push("Horário de início da terceira opção de data");
      }
      if (!this.request.eventInfo.dateOptions.third.end) {
        pendencies.push("Horário final da terceira opção de data");
      }
      if (this.request.eventInfo.suggestedThemes.length == 0) {
        pendencies.push("Temas para a participação em aula");
      }
      if (!this.request.eventInfo.themesDescription) {
        pendencies.push("Descrição de cada tema");
      }
      if (this.request.eventInfo.isManagerConductingAlone === "") {
        pendencies.push("Formato desejado para a Participação em Aula");
      }
      if (!this.request.eventInfo.eventType) {
        pendencies.push("Descrição do Formato");
      }
      if (!this.request.eventInfo.eventDescription) {
        pendencies.push("Descrição do formato sugerido");
      }

      return pendencies;
    }
  },

  mounted() {
    this.request.opportunity = this.opportunityBeingVisited._id;

    this.request.eventInfo.attendeeQty = this.minPublic;

    let themes = this.opportunityBeingVisited.lesson.themes;
    let specificThemes = this.opportunityBeingVisited.lesson.specificThemes;

    this.ddds = ddds;

    this.contact.cellphone = this.account.cellphone;
    this.contact.areacode = this.account.areacode;
    this.contact.lattes = this.account.lattes;
    this.contact.linkedin = this.account.linkedin;

    let index = themes.findIndex(t => {
      return t === "Outros Temas de Interesse do(a) professor(a)";
    });

    if (index !== -1) themes.splice(index, 1);
    themes.unshift("--- Negócios e Gestão ---");

    index = specificThemes.findIndex(t => {
      return t === "Outros Temas de Interesse do professor(a)";
    });

    if (index !== -1) specificThemes.splice(index, 1);
    specificThemes.unshift("--- Técnicos e Específicos ---");

    this.themesArray = themes.concat(specificThemes);
    this.themesArray.push("Outros Temas de Interesse do(a) professor(a)");

    if (this.opportunityBeingVisited.lesson.format) {
      if (this.opportunityBeingVisited.lesson.format == "online") {
        this.request.eventInfo.isOnline = true;
        this.hasFormat = true;
      } else if (this.opportunityBeingVisited.lesson.format == "faceToFace") {
        this.request.eventInfo.isOnline = false;
        this.hasFormat = true;
      }
    }
  }
};
</script>

<style scoped>
.modal-card-body {
  padding-top: 3rem;
  padding-bottom: 3rem;
}
.checkbox-bottom {
  padding-top: 0.5rem;
}
.infoIcon {
  color: #209cee;
  cursor: pointer;
}

.format-icon {
  cursor: pointer;
}
</style>
